import { Component, OnInit } from '@angular/core';
import { ClaimRow } from '../../../../../models/api/view/claim-view/claim-row';
import { getClaimKey } from '../../../../../functions/get-claim-key';
import {
  PropertyInfo,
  PropertyLossInfo,
  PropertyPolicyInfo,
  PropertyResponse,
} from '../../../../../models/api/view/claim/details/property/property-response';
import { BaseComponent } from '../../../../base/base.component';
import { CardComponent } from '../../../../core/panels/card.component';
import { DetailItemComponent } from '../../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../../core/panels/detail-panel/detail-panel.component';

@Component({
  selector: 'app-property-pr',
  imports: [DetailPanelComponent, DetailItemComponent, CardComponent],
  template: `
    <div class="tw-flex tw-w-full tw-gap-8 tw-py-8">
      <app-card label="Loss" class="tw-basis-1/3">
        <app-detail-panel [dataSource]="loss">
          <app-detail-item label="loss description" name="lossDescription" />
          <app-detail-item label="address" name="address" />
          <app-detail-item label="kind of loss" name="kindOfLoss" />
          <app-detail-item label="loss amount" name="lossAmount" format="c" />
          <app-detail-item label="contacted" name="contacted" />
        </app-detail-panel>
      </app-card>
      <app-card label="Policy" class="tw-basis-1/3">
        <app-detail-panel [dataSource]="policy">
          <app-detail-item label="mortgage" name="mortgage" />
          <app-detail-item label="name" name="name" />
          <app-detail-item label="subject to forms" name="subjectToForms" />
        </app-detail-panel>
      </app-card>
      <app-card label="Property" class="tw-basis-1/3">
        <app-detail-panel [dataSource]="property">
          <app-detail-item label="model" name="model" />
          <app-detail-item label="manufacturer" name="manufacturer" />
          <app-detail-item
            label="client owns property"
            name="clientOwnsProperty"
          />
          <app-detail-item
            label="damage begin date"
            name="damageBeginDate"
            format="d"
          />
          <app-detail-item
            label="damage end date"
            name="damageEndDate"
            format="d"
          />
          <app-detail-item label="serial number" name="serialNumber" />
          <app-detail-item label="year" name="year" />
          <app-detail-item
            label="business interrupted"
            name="businessInterrupted"
          />
        </app-detail-panel>
      </app-card>
    </div>
  `,
  styles: `
    .row div {
      height: 20px;
    }
  `,
})
export class PropertyPrComponent extends BaseComponent implements OnInit {
  claimRow: ClaimRow;
  propertyResponse: PropertyResponse;
  loss: PropertyLossInfo;
  policy: PropertyPolicyInfo;
  property: PropertyInfo;

  constructor() {
    super();
  }

  async ngOnInit(): Promise<void> {
    this.view.showLoading();

    const claimKey = getClaimKey();
    if (claimKey) {
      this.propertyResponse = await this.api.property.get(claimKey);
      this.loss = this.propertyResponse.loss;
      this.policy = this.propertyResponse.policy;
      this.property = this.propertyResponse.property;
    }

    this.claimRow = this.view.currentClaim();
    this.view.hideLoading();
  }
}
